import { Controller } from 'stimulus'
import Rails from 'rails-ujs'

export default class extends Controller {

  static targets = ["searchUserTextarea", "searchResults", "resultsList", ]

  connect() {}


  search() {
    var isUserSearch = !this.hasSearchUserTextareaTarget ? false : !this.searchUserTextareaTarget.classList.contains("is-hidden")
    var isGroupSearch = !this.hasSearchGroupTextareaTarget ? false : !this.searchGroupTextareaTarget.classList.contains("is-hidden")
    var permissionGroupName = null;
    if (isUserSearch) {
      if (!!this.searchUserTextareaTarget.dataset.permissionGroupName) {
        permissionGroupName = this.searchUserTextareaTarget.dataset.permissionGroupName;
      }
    }


    var queryRaw = isUserSearch ? this.searchUserTextareaTarget.value : this.searchGroupTextareaTarget.value
    if (queryRaw.length == 0) this.searchResultsTarget.innerHTML = ""
    
    if (!queryRaw) return;
    var currentItems = queryRaw.split(";").map(item => item.trim())
    var query = currentItems.pop().trim()
    
    if (query && query.length > 2) {
      fetch(`/admin/permissions/search?query=${query}&currentItems=${JSON.stringify(currentItems)}&searchType=${isUserSearch ? "users" : "groups"}${permissionGroupName != null ? `&permissionGroupName=${permissionGroupName}` : ''}`)
        .then(response => {
          return response.text()
        })
        .then(html => {
          this.searchResultsTarget.innerHTML = html
        })
    } else {
      this.searchResultsTarget.innerHTML = ""
    }
  }
  
  
  resetSearchResults() {
    document.querySelectorAll(".search-results-area").forEach(el => el.innerHTML = "")
  } 

  autocompleteItemInTextarea(event, keyboardSelectedItem=null) {
    var isUserSearch = !this.searchUserTextareaTarget.classList.contains("is-hidden")
    var isGroupSearch = !this.searchUserTextareaTarget.classList.contains("is-hidden")
    var searchTextareaTarget = isUserSearch ? this.searchUserTextareaTarget : this.searchGroupTextareaTarget


    var currentItems = searchTextareaTarget.value.split(";").map(item => item.trim())
    currentItems.pop()
    var selectedItem = keyboardSelectedItem == null ? event.target.dataset.itemname : keyboardSelectedItem
    currentItems.push(selectedItem)
    
    var currentItemsUnique = Array.from(new Set(currentItems.map(JSON.stringify)), JSON.parse)
    
    // if (searchTextareaTarget.value.trim().slice(-1) != ";") {
      
    // }

    searchTextareaTarget.value = currentItemsUnique.join("; ").trim() + "; "
    
    this.searchResultsTarget.querySelector(`.results-list--result[data-itemname="${selectedItem}"]`).classList.add("selected-item")
    // this.searchResultsTarget.innerHTML = ""

    // searchTextareaTarget.focus()
  }

  selectResultWithKeyboard(event) {
    if (this.searchResultsTarget.innerHTML === "") return;

    var isKeyUp = event.keyCode == 38;
    var isKeyDown = event.keyCode == 40;
    var isKeyEnter = event.keyCode == 13;

    if (isKeyUp || isKeyDown) {
      event.preventDefault()

       var lastItemIndex = this.resultsListTarget.querySelectorAll('.results-list--result').length-1

       if (this.resultsListTarget.querySelectorAll('.results-list--result[data-arrows-selected="true"]').length == 0) { // not selected
  
       if (isKeyDown) {
         this.resultsListTarget.querySelector('.results-list--result[data-arrows-selected="false"][data-item-index="0"]').dataset.arrowsSelected = true
       } else if (isKeyUp) {
         this.resultsListTarget.querySelector('.results-list--result[data-arrows-selected="false"][data-item-index="' + lastItemIndex + '"]').dataset.arrowsSelected = true
       }
        
      } else {
        var currentItemSelected = this.resultsListTarget.querySelector('.results-list--result[data-arrows-selected="true"]')
        var currentItemSelectedIndex = parseInt(currentItemSelected.dataset.itemIndex)
        var nextItemIndex;

        if (isKeyDown) {
          nextItemIndex = currentItemSelectedIndex == lastItemIndex ? 0 : (currentItemSelectedIndex+1)
        } else if (isKeyUp) {
          nextItemIndex = currentItemSelectedIndex == 0 ? lastItemIndex : (currentItemSelectedIndex-1)
        }


        currentItemSelected.dataset.arrowsSelected = false
        this.resultsListTarget.querySelector('.results-list--result[data-arrows-selected="false"][data-item-index="' + nextItemIndex + '"]').dataset.arrowsSelected = true
      }
    }

    if (isKeyEnter) {
      var currentItemSelected = this.resultsListTarget.querySelector('.results-list--result[data-arrows-selected="true"]')
      this.autocompleteItemInTextarea(event, currentItemSelected.dataset.itemname)
      event.preventDefault()
    }
  }

}